import { lazy } from 'react'

export default {
    path: '/report/interrogazione-consuntivi',
    title: 'Interrogazione consuntivi',
    authenticated: true,
    component: lazy(() => import('./filter'))
}